import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-disabled-add",
  "use": "icon-disabled-add-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-disabled-add\"><g fill=\"none\" fill-rule=\"evenodd\"><rect stroke=\"#DADCE1\" fill=\"#FFF\" x=\".5\" y=\".5\" width=\"35\" height=\"35\" rx=\"4\" /><path d=\"M10 10h16v16H10z\" /><path d=\"M10 10h16v16H10z\" /><path d=\"M18 12a1 1 0 0 1 1 1v4h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4.001L13 19a1 1 0 1 1 0-2l4-.001V13a1 1 0 0 1 1-1z\" fill=\"#DADCE1\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol